import axios from "axios";
import deploymentEnvironment from "../../client-utils/url/deploymentEnvironment.util.js";
const client = axios.create({
    baseURL: "https://app-sdbone-api-prod.azurewebsites.net",
});
client.interceptors.request.use((config) => {
    const path = window.location.host;
    const isLocalHost = path.includes("localhost");
    if (isLocalHost)
        config.baseURL = `https://app-sdbone-api-test.azurewebsites.net`;
    const deployment = deploymentEnvironment();
    if (!deployment)
        return config;
    const { domain } = deployment;
    const env = domain === "other" || isLocalHost ? "test" : domain;
    config.baseURL = `https://app-sdbone-api-${env}.azurewebsites.net`;
    return config;
});
export default client;
